import { useState } from "react";
import { InfoHint } from "./InfoHint";
import { Slider } from "@/components/ui/slider";
import { MoonStars } from "@phosphor-icons/react";

const zone = (v) => (v >= 67 ? { c: "#00e676", l: "зелёная зона" } : v >= 34 ? { c: "#ffea00", l: "жёлтая зона" } : { c: "#ff3b30", l: "красная зона" });
const fmt = (b) => `${String(Math.floor(b % 24)).padStart(2, "0")}:${String(Math.round((b % 1) * 60)).padStart(2, "0")}`;

export default function ForecastCard({ forecast }) {
  const [bed, setBed] = useState(23.5);
  if (!forecast) return null;
  const strain = forecast.today_strain ?? 10;
  const pred = Math.max(1, Math.min(99, Math.round(forecast.intercept + forecast.coef_bed * bed + forecast.coef_strain * strain)));
  const z = zone(pred);
  const now = new Date();
  const nowH = now.getHours() + now.getMinutes() / 60;
  const nowNorm = nowH < 12 ? nowH + 24 : nowH;
  const isEvening = nowNorm >= 20.5 && nowNorm <= 27;
  const predNow = isEvening
    ? Math.max(1, Math.min(99, Math.round(forecast.intercept + forecast.coef_bed * Math.min(27, Math.max(21.5, nowNorm)) + forecast.coef_strain * strain)))
    : null;
  return (
    <div className="glass-card p-5" data-testid="forecast-card">
      <div className="flex items-center gap-2 mb-1">
        <MoonStars size={18} weight="fill" className="text-[#a970ff]" />
        <h3 className="text-sm font-semibold">Прогноз восстановления на завтра<InfoHint text="Прогноз строится на сегодняшней нагрузке, сне и трендах последних дней. Помогает заранее спланировать интенсивность завтрашней тренировки." /></h3>
      </div>
      <p className="text-xs text-muted-foreground mb-4">
        Двигайте ползунок «во сколько лягу» — модель, обученная на ваших {forecast.n} ночах, предскажет завтрашнее восстановление при сегодняшней нагрузке {strain}.
      </p>
      <div className="flex items-center gap-6">
        <div className="text-center shrink-0" data-testid="forecast-value">
          <div className="font-heading text-4xl font-bold num" style={{ color: z.c }}>≈{pred}%</div>
          <div className="text-[10px] uppercase tracking-widest mt-1" style={{ color: z.c }}>{z.l}</div>
        </div>
        <div className="flex-1">
          <div className="flex justify-between text-xs text-muted-foreground mb-2">
            <span>Лягу в <span className="num font-semibold text-foreground">{fmt(bed)}</span></span>
            <span className="num">обычно ложитесь в {fmt(forecast.avg_bed)}</span>
          </div>
          <Slider value={[bed]} onValueChange={(v) => setBed(v[0])} min={21.5} max={26} step={0.25} data-testid="forecast-slider" />
          <div className="flex justify-between text-[10px] text-muted-foreground mt-1.5 num">
            <span>21:30</span><span>23:45</span><span>02:00</span>
          </div>
        </div>
      </div>
      <p className="text-[10px] text-muted-foreground mt-3">Регрессия по вашим данным: время отбоя + дневная нагрузка. Это оценка, а не гарантия.</p>
      {predNow != null && (
        <div className="mt-3 rounded-md bg-secondary/50 border border-border/40 px-3 py-2 text-xs flex items-center gap-2" data-testid="forecast-now">
          <span>🌙 Если лечь прямо сейчас ({String(now.getHours()).padStart(2, "0")}:{String(now.getMinutes()).padStart(2, "0")}) — завтра ≈</span>
          <span className="num font-bold" style={{ color: zone(predNow).c }}>{predNow}%</span>
        </div>
      )}
    </div>
  );
}
